import { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { PRODUCT_TYPE_WHEN_ROUTING, STARTMODE_WHEN_ROUTING } from '../../define/global';
import AppMain from '../AppMain';
import AsyncRendering from './AsyncRendering';
import ErrorPage from './ErrorPage';

const initState = {
  INIT: 'init',
  COMPLETE: 'complete',
  FAIL: 'fail'
};

const ShareViewStartModeRouter = ({ match, location }) => {
  return <AppMain match={match} location={location} />;
};

const AsyncRenderingSelector = ({ authCheck, children, match }) => {
  return authCheck ? <AsyncRendering match={match}>{children}</AsyncRendering> : <>{children}</>;
};

const StartModeRouter = ({ match, location, history }) => {
  const [state, setstate] = useState({ startMode: '', ok: initState.INIT, authCheck: false });

  useEffect(() => {
    const startMode = match.params.startMode;
    const authCheck = false || match.params.productType === PRODUCT_TYPE_WHEN_ROUTING.WHALE_SPACE;

    if (Object.values(STARTMODE_WHEN_ROUTING).includes(startMode) === true) {
      setstate({ startMode, ok: initState.COMPLETE, authCheck });
    } else {
      setstate({ startMode, ok: initState.FAIL, authCheck });
    }
  }, [match]);

  return (
    <>
      {state.ok === initState.COMPLETE && (
        <AsyncRenderingSelector authCheck={state.authCheck} match={match}>
          {state.startMode === STARTMODE_WHEN_ROUTING.SHARE_VIEW ? (
            <>
              <Route exact path={`${match.path}`}>
                <AppMain match={match} location={location} history={history} />
              </Route>
              <Route path={`${match.path}/:docId`} component={ShareViewStartModeRouter} />
            </>
          ) : (
            <AppMain match={match} location={location} history={history} />
          )}
        </AsyncRenderingSelector>
      )}
      {state.ok === initState.FAIL && (
        <ErrorPage
          msg={`${match.params.productType} 에서는  ${state.startMode}을 지원하지 않습니다. `}
        />
      )}
    </>
  );
};

export default StartModeRouter;
